export type MapMode = "map" | "split" | "list";
export interface MapState {
  estate?: string;
  development?: string;
  listing?: string;
  kind?: "all" | "buy" | "sale" | "rental" | "development" | "vacant_land";
  propertyType?: string;
  minPrice?: number;
  maxPrice?: number;
  bedrooms?: number;
  bathrooms?: number;
  status?: "active" | "on_show" | "under_offer" | "reserved";
  feature?: string;
  onShow?: boolean;
  bounds?: [number, number, number, number];
  mode: MapMode;
}

function numberValue(value: string | null): number | undefined { if (value === null || value === "") return undefined; const parsed = Number(value); return Number.isFinite(parsed) ? parsed : undefined; }

export function parseMapState(search: string): MapState {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const rawBounds = params.get("b")?.split(",").map(Number);
  const mode = params.get("view");
  const kind = params.get("kind");
  const minPrice = numberValue(params.get("min"));
  const maxPrice = numberValue(params.get("max"));
  const bedrooms = numberValue(params.get("beds"));
  const bathrooms = numberValue(params.get("baths"));
  const status = params.get("status");
  return {
    ...(params.get("e") ? { estate: params.get("e")! } : {}),
    ...(params.get("d") ? { development: params.get("d")! } : {}),
    ...(params.get("l") ? { listing: params.get("l")! } : {}),
    ...(kind === "all" || kind === "buy" || kind === "sale" || kind === "rental" || kind === "development" || kind === "vacant_land" ? { kind } : {}),
    ...(params.get("type") ? { propertyType: params.get("type")! } : {}),
    ...(minPrice !== undefined ? { minPrice } : {}),
    ...(maxPrice !== undefined ? { maxPrice } : {}),
    ...(bedrooms !== undefined ? { bedrooms } : {}),
    ...(bathrooms !== undefined ? { bathrooms } : {}),
    ...(status === "active" || status === "on_show" || status === "under_offer" || status === "reserved" ? { status } : {}),
    ...(params.get("feature") ? { feature: params.get("feature")! } : {}),
    ...(params.get("onShow") === "1" ? { onShow: true } : {}),
    ...(rawBounds?.length === 4 && rawBounds.every(Number.isFinite) ? { bounds: rawBounds as [number, number, number, number] } : {}),
    mode: mode === "map" || mode === "list" || mode === "split" ? mode : "split",
  };
}

export function serialiseMapState(state: MapState): string {
  const params = new URLSearchParams();
  if (state.estate) params.set("e", state.estate);
  if (state.development) params.set("d", state.development);
  if (state.listing) params.set("l", state.listing);
  if (state.kind) params.set("kind", state.kind);
  if (state.propertyType) params.set("type", state.propertyType);
  if (state.minPrice !== undefined) params.set("min", String(state.minPrice));
  if (state.maxPrice !== undefined) params.set("max", String(state.maxPrice));
  if (state.bedrooms !== undefined) params.set("beds", String(state.bedrooms));
  if (state.bathrooms !== undefined) params.set("baths", String(state.bathrooms));
  if (state.status) params.set("status", state.status);
  if (state.feature) params.set("feature", state.feature);
  if (state.onShow) params.set("onShow", "1");
  if (state.bounds) params.set("b", state.bounds.map((value) => Number(value.toFixed(5))).join(","));
  if (state.mode !== "split") params.set("view", state.mode);
  const value = params.toString(); return value ? `?${value}` : "";
}
